import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
  };

  const activeStyle = {
    color: '#9D91FF', // ✅ 활성화된 언어 색상 (파란색 예시)
    fontWeight: 'bold',
    cursor: 'pointer',
  };

  const inactiveStyle = {
    color: '#888', // 비활성화된 언어 색상
    cursor: 'pointer',
  };

  return (
    <div style={{ display: "flex", justifyContent: 'space-evenly', fontSize: "12px" }}>
      <div
        onClick={() => changeLang('ko')}
        style={i18n.language === 'ko' ? activeStyle : inactiveStyle}
      >
        KOR
      </div>
      <div>|</div>
      <div
        onClick={() => changeLang('en')}
        style={i18n.language === 'en' ? activeStyle : inactiveStyle}
      >
        ENG
      </div>
    </div>
  );
};

export default LanguageSwitcher;
